$(function() {
    disabledQuickBuy();
});

$(document).on('click', '.js-qck-add a', function(e) {
    //e.preventDefault();
    const $this = $(this);
  
    // if (!$this.hasClass('sold-out')) {
    //   quickAdd($this.data('id'));
    // }
});

function disabledQuickBuy() {
    if ($('.quickbuy-component').length > 0) {
        $('.quickbuy-component').each(function() {
            this.querySelectorAll('.js-qck-add ul li a').forEach((e) => {
                var size = e.getAttribute('data-size-value');
                var variant = e.closest('.quickbuy-component').querySelector('.js-qck-select option[data-size="' + size + '"]');

                e.setAttribute('data-id', variant.value);

                e.href = e.href + '?variant=' + variant.value;

                if (variant.getAttribute('disabled')) {
                    e.classList.add('sold-out');
                }
               
            });
        });
    }
}

function quickAdd(productId) {
    let formData = {
        'items': [{
            'id': productId,
            'quantity': 1
        }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
         return response.json();
       })
       .catch((error) => {
         console.error('Error:', error);
    });
}